import styled from 'styled-components';

export const AppFooterWrapper = styled.footer`
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.petrol};
  border-top: ${({ theme }) => theme.thickness.thick} solid ${({ theme }) => theme.colors.petrol};

  display: flex;
  justify-content: center;
`;

export const AppFooterText = styled.span`
  margin: ${({ theme }) => `${theme.space.s2} ${theme.space.none}`};
  padding: ${({ theme }) => `${theme.space.none} ${theme.space.s3}`};

  ${({ theme }) => theme.font.regularP}
`;
